import { Link } from 'react-router-dom';
import { useConsent } from '../lib/consent';

export default function CookieConsentBanner() {
  const { choice, accept, reject } = useConsent();

  if (choice !== null) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] bg-white border-t border-gray-200 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col md:flex-row items-center gap-4">
        <p className="text-sm text-gray-600 flex-1">
          We use essential cookies to keep you signed in. With your consent, we also show
          ads via Google AdSense, which may set advertising cookies. Read our{' '}
          <Link to="/privacy" className="text-blue-600 hover:underline">Privacy Policy</Link> to learn more.
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={reject}
            className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900"
          >
            Reject non-essential
          </button>
          <button
            onClick={accept}
            className="btn-primary text-sm"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
